module.exports = __webpack_public_path__ + "img/logo.ef019896.png";